import type { ElementType } from 'react';

import { ReadCareerHistory } from 'src/components/Profile/CareerHistory/ReadCareerHistory/ReadCareerHistory';
import { FinishResume } from 'src/components/Profile/CreateResume/FinishResume/FinishResume';
import { SimplePersonalDetails } from 'src/components/Profile/CreateResume/SimplePersonalDetails/SimplePersonalDetails';
import { ReadEducation } from 'src/components/Profile/Education/ReadEducation/ReadEducation';
import { ReadLanguages } from 'src/components/Profile/Languages/ReadLanguages';
import { ReadLicences } from 'src/components/Profile/Licences/ReadLicences/ReadLicences';
import { ReadNextRole } from 'src/components/Profile/NextRole/ReadNextRole/ReadNextRole';
import { ReadPersonalDetails } from 'src/components/Profile/PersonalDetails/ReadPersonalDetails/ReadPersonalDetails';
import { ProfileVisibilityV2Container } from 'src/components/Profile/ProfileVisibilityV2/ProfileVisibilityV2Container';
import { ReadResume } from 'src/components/Profile/Resume/ReadResume/ReadResume';
import { ReadSkills } from 'src/components/Profile/Skills/ReadSkills/ReadSkills';
import { ReadSummary } from 'src/components/Profile/Summary/ReadSummary/ReadSummary';
import { Tips } from 'src/components/Profile/Tips/Tips';
import {
  SUMMARY,
  CAREER_HISTORY,
  RESUME,
  NEXT_ROLE,
  SKILLS,
  PERSONAL_DETAILS,
  PROFILE_INSIGHTS,
  PROFILE_VISIBILITY_V2,
  EDUCATION,
  PROFILE_PAGE,
  CREATE_RESUME_PAGE,
  TIPS,
  FINISH_RESUME,
  LICENCES,
  LANGUAGES,
  SUGGESTIONS,
  VERIFICATIONS,
  REFERENCES,
  PROFILE_VISIBILITY,
  PEOPLE_SEARCH,
} from 'src/components/Router';
import type { Card, Page } from 'src/types';

import { PeopleSearch } from '../PeopleSearch/PeopleSearch.tsx';
import { ProfileInsights } from '../ProfileInsights/ProfileInsights';
import { References } from '../References/References';
import { Suggestions } from '../Suggestions/Suggestions';
import { Verifications } from '../Verifications/Verifications';
type Cards = Record<Page, Record<string, ElementType>>;

const cards: Cards = {
  [PROFILE_PAGE]: {
    [CAREER_HISTORY]: ReadCareerHistory,
    [EDUCATION]: ReadEducation,
    [LANGUAGES]: ReadLanguages,
    [LICENCES]: ReadLicences,
    [NEXT_ROLE]: ReadNextRole,
    [PERSONAL_DETAILS]: ReadPersonalDetails,
    [PROFILE_INSIGHTS]: ProfileInsights,
    [PROFILE_VISIBILITY]: ProfileVisibilityV2Container,
    [PROFILE_VISIBILITY_V2]: ProfileVisibilityV2Container,
    [RESUME]: ReadResume,
    [REFERENCES]: References,
    [SKILLS]: ReadSkills,
    [SUGGESTIONS]: Suggestions,
    [SUMMARY]: ReadSummary,
    [TIPS]: Tips,
    [VERIFICATIONS]: Verifications,
    [PEOPLE_SEARCH]: PeopleSearch,
  },
  [CREATE_RESUME_PAGE]: {
    [PERSONAL_DETAILS]: SimplePersonalDetails,
    [SUMMARY]: ReadSummary,
    [CAREER_HISTORY]: ReadCareerHistory,
    [LICENCES]: ReadLicences,
    [SKILLS]: ReadSkills,
    [LANGUAGES]: ReadLanguages,
    [EDUCATION]: ReadEducation,
    [FINISH_RESUME]: FinishResume,
  },
};

export const getComponent = ({
  card,
  page = PROFILE_PAGE,
}: {
  card: Card;
  page?: Page;
}): ElementType => cards[page][card];
